const COUNTRY_CODES = { AU: '+61', NZ: '+64' };

export function countryCodeByAlpha2(alpha2: string): string {
  if (Object.keys(COUNTRY_CODES).includes(alpha2)) {
    return COUNTRY_CODES[alpha2];
  }

  return '';
}
